import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { isFuture } from 'date-fns';
import { Auth2Service } from '~app/shared/services/auth2/auth2.service';

@Injectable({
  providedIn: 'root',
})
export class NewsAuthGuard {
  constructor(private readonly auth: Auth2Service, private readonly router: Router) {}
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let isValid = false;
    if (route.fragment) {
      if (this.isTokenValid(route.fragment)) {
        window.localStorage.setItem('newsAuthToken', route.fragment);
        const parsedUrl = state.url.substring(0, state.url.indexOf('#'));
        this.router.navigateByUrl(parsedUrl, {
          replaceUrl: true,
        });
        return false;
      }
    } else {
      console.log('validating session');
      const token = window.localStorage.getItem('newsAuthToken');
      isValid = this.isTokenValid(token);
    }

    if (isValid) {
      return true;
    } else {
      this.auth.redirectToLogin();
      return false;
    }
  }

  private isTokenValid(token: string): boolean {
    try {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const expiration = tokenData.exp * 1000;
      return isFuture(expiration);
    } catch (error) {
      return false;
    }
  }
}
